module.exports = __webpack_public_path__ + "img/DE06102.0c4b07a8.png";